import type { SelectFieldOption } from '@/components/inputs/CustomSelectField'
import type { Site } from '@/features/site/types/site'

export function getSiteOptions(sites: Site[]): SelectFieldOption<string>[] {
  return sites.map(({ uuid, name }) => ({
    id: uuid!,
    label: name!,
    value: uuid!,
  }))
}
